<template>
	<div class="page-goods page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">调拨列表</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>调拨管理</el-breadcrumb-item>
							<el-breadcrumb-item>调拨列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
					<el-button type="primary" class="btn-bg-p" @click="handleStockAllot('add')">添加工单 <i
							class="el-icon-plus"></i></el-button>
					<!-- <el-button type="primary" class="btn-bg-r" @click="delmultiple()">批量删除</el-button> -->
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="work_number" label="工单编号：" style="margin-bottom: 0;">
							<el-input v-model="form_search.work_number" size="small" placeholder="工单编号" clearable>
							</el-input>
						</el-form-item>
						<el-form-item prop="output_desk_number" label="调出店铺：">
							<el-select size="small" filterable v-model="form_search.output_desk_number" placeholder="请选择">
								<el-option v-for="item in init_data.desk_list" :key="item.number" :label="item.name"
									:value="item.number">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="input_desk_number" label="调入店铺：">
							<el-select size="small" filterable v-model="form_search.input_desk_number" placeholder="请选择">
								<el-option v-for="item in init_data.desk_list" :key="item.number" :label="item.name"
									:value="item.number">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时间区间：">
							<el-select v-model="form_search.lately_day" size="small" placeholder="请选择"
								@change="changeSelect">
								<el-option v-for="item in init_data.time_list" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="创建时间：">
							<el-date-picker size="small" clearable v-model="create_range" type="daterange"
								range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								value-format="yyyy-MM-dd">
							</el-date-picker>
						</el-form-item>
						<el-form-item prop="status" label="状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择">
								<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
				</div>
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;"
							@selection-change="handleSelectionChange">
							<el-table-column prop="id" width="55" label="ID" align="center"></el-table-column>
							<el-table-column prop="allot_number" align="center" label="工单编号" min-width="120">
							</el-table-column>
							<!-- <el-table-column prop="output_desk_name" align="center" label="调出店铺" min-width="150">
							</el-table-column> -->
							<el-table-column prop="input_desk_name" align="center" label="关联店铺" min-width="150">
								<template slot-scope="scope">
									<span>{{scope.row.output_desk_name}} > > {{scope.row.input_desk_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="product_count" align="center" label="调拨总数" min-width="80">
							</el-table-column>
							<!-- <el-table-column prop="total_amount" align="center" label="合计金额" min-width="100">
							</el-table-column> -->
							<el-table-column prop="admin_name" align="center" label="操作账号" min-width="80">
							</el-table-column>
							<el-table-column prop="worker_name" align="center" label="操作员工" min-width="80">
							</el-table-column>
							<el-table-column prop="m_time" align="center" label="完成时间" min-width="160">
							</el-table-column>
							<el-table-column prop="status" align="center" label="状态" min-width="80" fixed="right">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.status_name}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="operating" align="right" label="操作" min-width="200" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-s" type="primary" size="mini"
										@click="dlgShowWork(scope.row)">工单详情</el-button>
									<el-button class="option-btn btn-bd-r" type="primary" size="mini"
										@click="stockDetail(scope.row.allot_number)">库存记录
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 添加工单 -->
		<el-dialog class="dialog-export goods-dialog" :title="dlg_goods.title" :visible.sync="dlg_goods.visible"
			width="1000px" @closed="closeStockAllot" :close-on-click-modal="false">
			<el-form ref="formStockAllot" :model="dlg_goods.form" label-width="120px" :rules="dlg_goods.rules"
				@submit.native.prevent>
				<el-row :gutter="24">
					<el-col :span="8">
						<el-form-item prop="output_desk_number" label="出库店铺：">
							<el-select size="small" v-model="dlg_goods.form.output_desk_number" placeholder="请选择">
								<el-option v-for="item in dlg_goods.init_data.desk_list" :key="item.number"
									:label="item.name" :value="item.number">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="input_desk_number" label="入库店铺：">
							<el-select size="small" v-model="dlg_goods.form.input_desk_number" placeholder="请选择">
								<el-option v-for="item in dlg_goods.init_data.desk_list" :key="item.number"
									:label="item.name" :value="item.number">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item prop="password" label="员工密码：" :error="dlg_goods.error.password">
							<el-input size="small" v-model="dlg_goods.form.password" placeholder='请输入员工密码' clearable>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="24">
					<el-col :span="8">
						<el-form-item label="商品名称：">
							<el-select size="small" v-model="dlg_goods.add_item.stock_number" placeholder="请选择" @change="changeAddItemProduct">
								<el-option v-for="item in dlg_goods.init_data.product_list" :key="item.stock_number"
									:label="item.name" :value="item.stock_number">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="商品数量：">
							<el-input size="small" v-model="dlg_goods.add_item.count" placeholder='请输入商品数量' clearable>
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-button @click="addProductFromList">添加调拨</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-table :data="dlg_goods.products" border style="width: 100%;" height="350">
						<el-table-column prop="stock_number" label="商品编号" width="150">
						</el-table-column>
						<el-table-column prop="product_name" label="商品名称">
						</el-table-column>
						<el-table-column prop="count" label="商品数量">
							<template slot-scope="scope">
								<span v-if="!scope.row.is_edit">{{scope.row.count}}</span>
								<el-input v-if="scope.row.is_edit" v-model="scope.row.count" />
							</template>
						</el-table-column>
						<el-table-column prop="unit" label="商品单位">
						</el-table-column>
						<!-- <el-table-column prop="amount" label="合计金额">
						</el-table-column> -->
						<el-table-column fixed="right" label="操作" width="100">
							<template slot-scope="scope">
								<el-button @click="editProductFromList(scope.$index, scope.row)" type="text" size="small">修改</el-button>
								<el-button @click="deleteProductFromList(scope.row)" type="text" size="small">删除</el-button>
							</template>
					 </el-table-column>
					</el-table>
				</el-row>
				</el-row>
				<el-row style="margin-top: 15px;" :gutter="20">
					<el-col :span="12">
						<el-form-item prop="remark" label="工单备注：" :error="dlg_goods.error.remark">
							<el-input v-model="dlg_goods.form.remark" type="textarea" :rows="3" size="small"
								placeholder="请输入备注"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_goods.visible = false">取 消</el-button>
				<el-button type="primary" @click="submitStockAllot()" :loading="dlg_goods.btn_loading">确认</el-button>
			</span>
		</el-dialog>
		<!-- 查看工单 -->
		<el-dialog class="dialog-export goods-dialog" :title="dlg_show_work.title" :visible.sync="dlg_show_work.visible"
			width="1000px" @closed="closeShowWork" :close-on-click-modal="false">
			<el-descriptions style="margin-bottom: 20px;" title="工单详情信息" border>
				<el-descriptions-item label="工单编号">{{dlg_show_work.allot_number}}</el-descriptions-item>
				<el-descriptions-item label="调拨店铺">{{dlg_show_work.output_desk_name}} > > {{dlg_show_work.input_desk_name}}</el-descriptions-item>
				<el-descriptions-item label="操作人员">{{dlg_show_work.worker_name}}</el-descriptions-item>
				<el-descriptions-item label="调拨数量">{{dlg_show_work.product_count}}</el-descriptions-item>
				<el-descriptions-item label="创建时间">{{dlg_show_work.c_time}}</el-descriptions-item>
				<el-descriptions-item label="备注">
					<el-tag size="small">{{dlg_show_work.remark}}</el-tag>
				</el-descriptions-item>
			</el-descriptions>
			<el-table :data="dlg_show_work.product_list" height="350" border style="width: 100%">
				<el-table-column prop="stock_number" label="商品编号" width="180">
				</el-table-column>
				<el-table-column prop="product_name" label="商品名称" width="180">
				</el-table-column>
				<el-table-column prop="count" label="数量" width="180">
				</el-table-column>
				<el-table-column prop="unit" label="单位">
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_show_work.visible = false">取 消</el-button>
			</span>
		</el-dialog>
		<!-- 灰板 -->
		<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
			<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				create_range: '',
				//搜索
				category_select: [],
				form_search: {
					output_desk_name: this.$route.query.output_desk_name == undefined ? '' : this.$route.query.output_desk_name,
					input_desk_name: this.$route.query.input_desk_name == undefined ? '' : this.$route.query.input_desk_name,
					work_number: this.$route.query.work_number == undefined ? '' : this.$route.query.work_number,
					lately_day: -1,
					start_date: '',
					end_date: ''
				},
				optionProps: {
					value: "id",
					label: "value",
					children: "childrens"
				},
				init_data: {
					desk_list: [],
					time_list: [{
						id: -1,
						name: '不限'
					}, {
						id: 7,
						name: '近7天'
					}, {
						id: 30,
						name: '近1个月'
					}, {
						id: 90,
						name: '近3个月'
					}, {
						id: 180,
						name: '近半年'
					}]
				},
				baseUrl: this.$client.IMG_URL,
				timestamp: new Date().getTime(),
				multipleSelection: [],
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 30,
						total: 130
					}
				},
				dlg_goods: {
					id: '',
					visible: false,
					btn_loading: false,
					api: '',
					title: '',
					hide_upload: false,
					hide_more_upload: false,
					hasUpload: false,
					form: {
						output_desk_number: '',
						input_desk_number: '',
						product_json: '',
						remark: '',
						password: '',
					},
					error: {
						desk_number: '',
						product_json: '',
						remark: '',
						password: '',
					},
					reset_form: {},
					init_data: {
						desk_list: [],
						product_list: [],
						status_list: []
					},
					rules: {
						desk_number: {
							required: true,
							message: '请选择所属店铺',
							trigger: ['change', 'blur']
						},
						password: {
							required: true,
							message: '请输入员工密码',
							trigger: ['change', 'blur']
						},
					},
					params: {
						action: this.$client.API_URL + '/adminapi/upload/images',
						data: {
							path: 'goods'
						},
						headers: {
							token: localStorage.getItem('token')
						}
					},
					products: [],
					add_item:{
						stock_number: '',
						product_name: '',
						unit: '',
						count: 0,
						amount: 0,
						is_edit: false,
					},
				},
				dlg_show_work: {
					id: '',
					visible: false,
					api: '',
					title: '',
					size: 300,
					allot_number: '',
					output_desk_name: '',
					input_desk_name: '',
					worker_name: '',
					status_name: '',
					product_count: 0,
					total_amount: 0,
					c_time: '',
					product_list: [{
						stock_number: '',
						product_name: '',
						count: '',
						unit: '',
						amount: '',
					}],
					remark: '',
				},
				dlg_preview: {
					visible: false,
					img_url: ''
				}
			}
		},
		created() {
			document.title = '商品管理';
			this.dlg_goods.reset_form = Object.assign({}, this.dlg_goods.form);
			this.getList();
		},
		methods: {
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			changeSelect() {
				this.create_range = '';
				this.form_search.start_date = '';
				this.form_search.end_date = '';
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.p = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				var desk_default = [{
					number: '',
					name: '全部'
				}];
				var status_default = [{
					id: -1,
					name: '全部'
				}];
				this.$client.get('/adminapi/stockallot/list', params, function(res, message) {
					_this.table_data.list = res.list;
					_this.table_data.page_info = res.pager;
					_this.dlg_goods.init_data.desk_list = res.desk_name_list;
					_this.dlg_goods.init_data.product_list = res.stock_product_name_list;
					_this.dlg_goods.init_data.status_list = res.status_name_list;
					_this.init_data.desk_list = desk_default.concat(res.desk_name_list);
					_this.init_data.status_list = status_default.concat(res.status_name_list);
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			stockDetail(work_number) {
				var data = {
					work_number: work_number,
				};
				this.$util.goTo('/stock/stocklog', {
					query: data
				})
			},
			handleSizeChange(val) {
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.table_data.page_info.page = val;
				this.getList();
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 查看工单
			dlgShowWork(data) {
				this.dlg_show_work.visible = true;
				this.dlg_show_work.title = data.allot_number + '调拨清单';
				this.dlg_show_work.allot_number = data.allot_number;
				this.dlg_show_work.output_desk_name = data.output_desk_name;
				this.dlg_show_work.input_desk_name = data.input_desk_name;
				this.dlg_show_work.worker_name = data.worker_name;
				this.dlg_show_work.status_name = data.status_name;
				this.dlg_show_work.product_count = data.product_count;
				this.dlg_show_work.total_amount = data.total_amount;
				this.dlg_show_work.c_time = data.c_time;
				this.dlg_show_work.product_list = data.product_list;
				this.dlg_show_work.remark = data.remark;
			},
			closeShowWork() {

			},
			// 添加工单
			handleStockAllot(type, data) {
				this.dlg_goods.visible = true;
				this.dlg_goods.title = '创建调拨单';
				this.dlg_goods.api = '/adminapi/stockallot/createstockallot';
			},
			// 修改商品
			changeAddItemProduct(val){
				let o = this.dlg_goods.init_data.product_list;
				this.dlg_goods.add_item.product_name = o.find(t => t.stock_number == val).name;
				this.dlg_goods.add_item.unit = o.find(t => t.stock_number == val).unit;
			},
			// 添加商品操作项
			addProductFromList(){
				if(!this.dlg_goods.add_item.count) {
					this.$message('请设置商品数量，且不能为0');
					return false;
				}
				if(this.dlg_goods.products.map(t => t.stock_number).indexOf(this.dlg_goods.add_item.stock_number) != -1){
					this.$message('该商品已经存在了，请勿重复添加');
					return false;
				}
				let target = JSON.parse(JSON.stringify(this.dlg_goods.add_item));
				this.dlg_goods.products = this.dlg_goods.products.concat(target);
			},
			editProductFromList(index, row){
				this.dlg_goods.products[index].is_edit = !this.dlg_goods.products[index].is_edit;
			},
			deleteProductFromList(row){
				this.dlg_goods.products = this.dlg_goods.products.filter(t => t.stock_number != row.stock_number);
			},
			// deleteStockAllot(id) {
			// 	var _this = this;
			// 	this.$confirm('确定要删除？', "", {
			// 			confirmButtonText: "确定",
			// 			cancelButtonText: "取消",
			// 			iconClass: "icon-delete el-icon-delete",
			// 			customClass: "my-confirm-box",
			// 			center: true,
			// 		})
			// 		.then(() => {
			// 			_this.$client.post('/adminapi/productsku/delete', {
			// 				id: id
			// 			}, function(res, message) {
			// 				_this.getList();
			// 			}, function(res) {

			// 			});
			// 		})
			// 		.catch(() => {});
			// },
			submitStockAllot() {
				var _this = this;
				_this.$refs['formStockAllot'].validate((valid) => {
					if (valid) {
						if(!this.dlg_goods.products.length){
							_this.$message('请添加调拨商品');
							return false;
						}
						if(this.dlg_goods.form.input_desk_number == this.dlg_goods.form.output_desk_number){
							_this.$message('出库与入库店铺不能相同');
							return false;
						}
						this.dlg_goods.form.product_json = JSON.stringify(this.dlg_goods.products);
						this.dlg_goods.btn_loading = true;
						this.$client.post(this.dlg_goods.api, this.dlg_goods.form, function(res, message) {
							_this.$message(message);
							_this.getList();
							_this.dlg_goods.btn_loading = false;
							_this.dlg_goods.visible = false;
						}, function(message) {
							_this.dlg_goods.btn_loading = false;
							if ((typeof message) === 'object') {
								for (var key in message) {
									_this.dlg_goods.error[key] = message[key];
								}
							} else {
								_this.$message(message)
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeStockAllot() {

				this.dlg_goods.products = [];
				this.dlg_goods.add_item = {};
				for (var key in this.dlg_goods.form) {
					this.dlg_goods.form[key] = this.dlg_goods.reset_form[key];
				}
				this.$nextTick(() => {
					this.$refs.formStockAllot.clearValidate();
				})
			},
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			//console.log(self.clientHeight);
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>
	.page-goods .el-upload--picture-card {
		line-height: 80px;
	}

	.page-goods .el-upload--picture-card,
	.el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}

	.hide-upload .el-upload--picture-card {
		display: none;
	}

	.status-2 {
		color: #9a9a9a;
	}

	.status-1 {
		color: #F31A5C;
	}

	.status-0 {
		color: #F27918;
	}

	.status-3 {
		color: #0C67F0;
	}

	.status-9 {
		color: #04B365;
	}

	.status-10 {
		color: #666;
	}

	.option-btn {
		margin: 5px;
	}
</style>
<style scoped>
	.img-tips {
		color: #f31a5c;
		font-size: 12px;
	}
</style>
